<template>
  <div class="cont">
    <b-card-body>
      <b-card class="EquationEditorContainer">
        <b-row>
          <b-col>
            <b-form-textarea class="equationEditorInput" v-model="equationTrate" /> <br />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span class="filter-kpi filter" title="Filtre por nome ou cabeçalho das variáveis"
              alt="Filtre por nome ou cabeçalho das variáveis">
              <label for="filter-kpi">{{ $t('filtro') }}</label>
              <input type="text" name="filter-kpi" class="ml-1 sample1-filter-input" v-model="filter"
                placeholder="Nome ou Cabeçalho" />
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="selectAndClickSection">
            <div class="row2Col1">
              <div class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
                <Loading v-if="this.loaded" />
                <table v-else class="table table-hover table-sm">
                  <thead class="thead-dark">
                    <th scope="col">VARIÁVEIS DO PLANO</th>
                  </thead>
                  <div>
                    <template v-if="this.filteredItensList.length == 0">Sem dados para visualização<br /></template>
                    <tbody v-else>
                      <tr v-for="item in this.filteredItensList" :key="item">
                        <td @click="getInputButtom(item)" class="text-truncate tableTxt" style="text-overflow: ellipsis">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </div>
                </table>
              </div>
            </div>
            <div class="calc mx-auto">
              <div class="keyboardCalcRow">
                <button @click="getInputButtom(1)">1</button>
                <button @click="getInputButtom(2)">2</button>
                <button @click="getInputButtom(3)">3</button>
                <button @click="getInputButtom(4)">4</button>
                <button @click="getInputButtom(5)">5</button>
              </div>
              <div class="keyboardCalcRow">
                <button @click="getInputButtom(6)">6</button>
                <button @click="getInputButtom(7)">7</button>
                <button @click="getInputButtom(8)">8</button>
                <button @click="getInputButtom(9)">9</button>
                <button @click="getInputButtom(0)">0</button>
              </div>
              <div class="keyboardCalcRow">
                <button @click="getInputButtom('+')">+</button>
                <button @click="getInputButtom('-')">-</button>
                <button @click="getInputButtom('/')">/</button>
                <button @click="getInputButtom('*')">*</button>
                <button @click="getInputButtom('.')">.</button>
              </div>
              <div class="keyboardCalcRow" v-if="mdp">
                <button @click="getInputButtom('√')">√</button>
                <button @click="getInputButtom('^')">
                  x<sup><i>n</i></sup>
                </button>
                <button @click="getInputButtom('(')">(</button>
                <button @click="getInputButtom(')')">)</button>
                <button v-if="mdp" @click="clearEquationInput()">C</button>
              </div>
              <div class="keyboardCalcRow">
                <button class="backspace" @click="backSpaceInput()">←</button>
                <button :class="mdp ? 'saveButton' : 'saveButtonWithMDP'" @click="salvar">=</button>
                <button v-if="!mdp" @click="clearEquationInput()">C</button>
              </div>
            </div>
          </b-col>
        </b-row><br />
        <b-row class="groupBtn">
          <div>
            <img id="" src="@/assets/assinarEconfirmar.png" style="margin-left: 30px; max-height: 35px;"
              :title="$t('salvar')" alt="Salvar" @click="salvar" />
            <img id="" src="@/assets/sair.png" style="margin-left: 30px; max-height: 35px;" :title="$t('cancelar')"
              alt="Cancelar" @click="$bvModal.hide(`${nameModal}`)" />
          </div>
        </b-row>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import axios from "axios";
import Loading from "@/components/template/Loading2.vue";

export default {
  name: "EquationEditor",
  components: { Loading },
  props: ["equation", "nameModal", "mdp"],
  watch: {
    filter(value) {
      if (value == "") {
        this.filteredItensList = this.varList
      }
      else {
        this.filteredItensList = this.varList.filter(
          (d) =>
            d.toUpperCase().includes(value.toUpperCase())
        );
      }
    }
  },
  data() {
    return {
      varList: [],
      filteredItensList: [],
      equationTrate: "",
      equationRaw: [],
      equationNumberAux: [],
      loaded: true,
      lastNum: false,
      varEquation: false,
      filter: ""
    };
  },
  methods: {
    async loadProductioPlanItensList() {
      const url = `${urlMainAPI}/getproductionplanitemlist`;
      await axios
        .get(url)
        .then((res) => {
          this.varList = res.data.map(x => x.name);
          this.filteredItensList = res.data.map(x => x.name);
          this.loaded = false;
        })
        .catch();
    },
    async salvar() {
      let obj = {}
      if (this.equationTrate == "") {
        this.$emit("finalEquation", this.equationTrate);
        this.$bvModal.hide(`${this.nameModal}`);
        return;
      }

      if (this.equationTrate.toUpperCase().includes("SQRT")) {
        showError(this.$t('a-equacao-nao-pode-conter-a-palavra-reservada-sqrt'));
        return;
      }

      obj.equation = this.equationTrate;

      const url = `${urlMainAPI}/validateproductionplanitemequation`;
      await axios
        .post(url, obj)
        .then((res) => {
          defaultSuccess(res.data);
          this.$emit("finalEquation", this.equationTrate);
          this.$bvModal.hide(`${this.nameModal}`);
        })
        .catch()
    },
    getInputButtom(value) {
      this.equationTrate += value;
      this.filter = ""
    },
    backSpaceInput() {
      this.equationTrate = this.equationTrate.length > 0 ? this.equationTrate.substring(0, this.equationTrate.length - 1) : "";
    },
    clearEquationInput() {
      this.equationTrate = "";
    },
  },
  created() {
    this.loadProductioPlanItensList();
    this.equationTrate = this.equation;
  },
};
</script>

<style scoped>
.EquationEditorContainer {
  max-width: 600px;
  min-height: 200px;
  margin: auto;
}

td {
  cursor: pointer;
}

button {
  padding: 2px;
  width: 35px;
  height: 35px;
  border: 1px solid black;
  border-radius: 3px;
  background: #232526;
  color: white;
  margin: 3px;
  cursor: pointer;
  outline: none;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 15px;
  box-shadow: 0 2.5px rgb(158, 158, 158);
}

button:hover {
  background-color: #1e2020;
}

button:active {
  background-color: #232526;
  box-shadow: 0 1px rgb(173, 115, 115);
  transform: translateY(2px);
}

.equationEditorInput {
  background-color: #e9ecef;
}

.saveButton {
  width: 117px !important;
  text-align: center;
}

.saveButtonWithMDP {
  width: 80px !important;
  text-align: center;
}

.backspace {
  width: 78px !important;
  text-align: center;
}

table {
  border-collapse: initial;
  border-spacing: initial;
}

.selectAndClickSection {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.rowcalc {
  margin-bottom: 10px;
}

.calc {
  display: block;
}

.keyboardCalcRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.my-custom-scrollbar {
  max-height: 210px;
  overflow: auto;
  margin: 0px auto;
  padding-left: 0px;
  padding-right: 0px;
  min-width: 242px;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.waitTxt {
  justify-content: center;
  /* font-weight: bold; */
  background: black;
  color: white;
  margin: 10px auto;
  min-width: 300px;
  max-width: 400px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.row2Col1 {
  margin: auto;
}

.filter {
  margin-left: 27px;
}

@media only screen and (max-width: 992px) {
  .calc {
    order: 1;
    min-width: 242px;
  }

  .row2Col1 {
    order: 2;
    margin-top: 20px;
  }

}
</style>
